module.exports = {"id":"dp2_1l3q5","text":"Interacting Through Digital Technologies","instructions":"Which feature allows robots to perceive their environment?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l3q5-a1","text":"Sensors collecting environmental data","score":3.7},{"id":"dp2_1l3q5-a2","text":"User preference settings only","score":1.3},{"id":"dp2_1l3q5-a3","text":"Manual task descriptions","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l3q5.json
// module id = 996
// module chunks = 41